import { defineMessages, injectIntl } from 'react-intl';
import { Link } from '@lifeomic/chroma-react/components/Link';
import { withStyles } from '@lifeomic/chroma-react/styles';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import React from 'react';

const messages = defineMessages({
  allFiles: {
    id: 'filePathCrumbs.allFiles',
    defaultMessage: 'All Files',
  },
});

const styles = theme => ({
  container: {
    fontWeight: theme.typography.fontWeightRegular,
    marginBottom: theme.spacing(4),
  },
});

class FilePathCrumbs extends React.PureComponent {
  handleClick = (onPartClick, path) => e => {
    onPartClick(path);
  };

  render() {
    const {
      baseUrl,
      classes,
      intl: { formatMessage },
      onPartClick,
      path,
    } = this.props;

    const splitPaths = path && path.split('/');

    // Used to define the indvidual segments of a path, but also the "fullPath"
    // up to the index of the segment.
    // Ex: path = '/foo/bar/baz'
    //      - { segment: 'foo', fullPath: 'foo' }
    //      - { segment: 'bar', fullPath: 'foo/bar' }
    //      - { segment: 'baz', fullPath: 'foo/bar/baz' }
    const pathSegments =
      splitPaths &&
      splitPaths.map((seg, segIndex) => {
        const precedingPathSegments = [...splitPaths].splice(0, segIndex + 1);

        return {
          segment: seg,
          fullPath: precedingPathSegments.join('/'),
        };
      });

    return (
      <h3 className={classes.container}>
        <Link to={baseUrl()} onClick={this.handleClick(onPartClick, baseUrl())}>
          {formatMessage(messages.allFiles)}
        </Link>
        {pathSegments &&
          pathSegments.map((p, i) => (
            <React.Fragment key={i}>
              <span> / </span>
              <Link
                to={baseUrl({ path: p.fullPath })}
                className={classes.link}
                onClick={this.handleClick(
                  onPartClick,
                  baseUrl({ path: p.fullPath }),
                )}
              >
                {p.segment}
              </Link>
            </React.Fragment>
          ))}
      </h3>
    );
  }
}

FilePathCrumbs.propTypes = {
  baseUrl: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  onPartClick: PropTypes.func,
  path: PropTypes.string.isRequired,
};

export default compose(injectIntl, withStyles(styles))(FilePathCrumbs);
